import { DotSpinner } from "@smartrr/shared/customerPortal/components/DotSpinner";
import React, { forwardRef } from "react";

export interface IReturnFromEmail {
  email: string;
  password: string;
  hiddenFormSubmitBtnRef: React.MutableRefObject<HTMLButtonElement | null>;
}

export const ReturnFromEmail = forwardRef(({ email, password, hiddenFormSubmitBtnRef }: IReturnFromEmail, _) => {
  return (
    <section>
      <div>
        <DotSpinner />
      </div>
      <div style={{ display: "none" }}>
        {/* Note: this appended into the shopify auth form and therefore wrapping this in its own form will cause unexpected behavior i.e. you can't log in  */}
        <input type="email" value={email ?? ""} name="customer[email]" />
        <input type="password" value={password ?? ""} name="customer[password]" />
        <button ref={hiddenFormSubmitBtnRef} type="submit">
          Submit
        </button>
      </div>
    </section>
  );
});
